// import Header from "../Header";
// import { SalesmanSidebarMenu } from "../sidebar/SalesmanSidebarMenu";
// import { SalesmanName } from "../../atoms/SalesmanName";
//
//
// const SalesmanHeader = () => {
//   return <Header name={<SalesmanName/>} sideBarMenu={<SalesmanSidebarMenu/>}/>
// };
// export default SalesmanHeader;

import React from "react";
import ResponsiveHeader from "./ResponsiveHeader";
import { SalesmanSidebarMenu } from "../sidebar/SalesmanSidebarMenu";
import { SalesmanName } from "../../atoms/SalesmanName";
import { LogoutModal } from "../LogoutModal";

const SalesmanHeader = () => {
    return (
        <ResponsiveHeader
            name={null}
            title="BLOCKs"
            navItems={[<LogoutModal key="logout" />]}
            sidebar={<SalesmanSidebarMenu />}
        />
    );
};

export default SalesmanHeader;